import * as Sentry from "@sentry/react";

const redirectURLs = {
  'babakocsi-markak-c500000882#!/': 'babakocsi-markak-c500000882',
  'babakocsi-markak-c500000882#!/abc-design-babakocsi':
    'abc-design-babakocsik-c500003391',
  'babakocsi-markak-c500000882#!/bebe-confort-babakocsi':
    'bebe-confort-babakocsik-c500003392',
  'babakocsi-markak-c500000882#!/britax-romer-babakocsi':
    'britax-romer-babakocsik-c500003393',
  'babakocsi-markak-c500000882#!/bugaboo-babakocsi':
    'bugaboo-babakocsik-c500003394',
  'babakocsi-markak-c500000882#!/cbx-babakocsi': 'cbx-babakocsik-c500003395',
  'babakocsi-markak-c500000882#!/cybex-babakocsi':
    'cybex-babakocsik-c500003396',
  'babakocsi-markak-c500000882#!/fisher-price-babakocsi':
    'fisher-price-babakocsik-c500003397',
  'babakocsi-markak-c500000882#!/gb-babakocsi': 'gb-babakocsik-c500003398',
  'babakocsi-markak-c500000882#!/hauck-babakocsi':
    'hauck-babakocsik-c500003399',
  'babakocsi-markak-c500000882#!/hauck-disney-babakocsi':
    'hauck-disney-babakocsik-c500003400',
  'babakocsi-markak-c500000882#!/joie-babakocsi': 'joie-babakocsik-c500003401',
  'babakocsi-markak-c500000882#!/maxi-cosi-babakocsi':
    'maxi-cosi-babakocsik-c500003402',
  'babakocsi-markak-c500000882#!/migo-babakocsi': 'migo-babakocsik-c500003403',
  'babakocsi-markak-c500000882#!/nania-babakocsi':
    'nania-babakocsik-c500003404',
  'babakocsi-markak-c500000882#!/peg-perego-babakocsi':
    'peg-perego-babakocsik-c500003405',
  'babakocsi-markak-c500000882#!/safety-1st-babakocsi':
    'safety-1st-babakocsik-c500003407',
  'babakocsi-markak-c500000882#!/stokke-babakocsi':
    'stokke-babakocsik-c500003408',
  'babakocsi-markak-c500000882#!/thule-babakocsi':
    'thule-babakocsik-c500003409',
  'babakocsi-markak-c500000882#!/touragoo-babakocsi':
    'touragoo-babakocsik-c500003410',
};

export default () => {
  const uri = window?.location?.pathname.substring(1) + window?.location?.hash;
  if (redirectURLs[uri] && redirectURLs[uri] != '') {
    Sentry.captureMessage(`Static redirect activated: ${uri}`);
    window.location.href = redirectURLs[uri];
  }
};
